// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entryCheckLabel,.entryCheckLabelbold{margin:0 0 0 5px;font-size:medium;text-align:left;max-width:420px}.entryCheckLabelbold{font-weight:700}", ""]);
// Exports
module.exports = exports;
